export default "__VITE_ASSET__4c320a27__"